
export default [
  {
    path: 'ventas',
    name: 'pos.venta',
    redirect: { name: 'pos.venta.home' },
    component: () => import('@/views/pos/venta/VentasHome.vue'),
    children: [
      {
        path: '',
        name: 'pos.venta.home',
        component: () => import('@/views/pos/venta/components/VentasHomeList.vue'),
      },
     
    ],

  },
  {
    path: 'ventas/conusltar',
    name: 'pos.venta.consultar',
    props: { tipoComprobante: 'ventas' },
    redirect: { name: 'pos.venta.consultar.home' },

    component: () => import(/* webpackChunkName: "about" */ '@/views/pos/venta/VentaConsultar.vue'),
    children: [
      {
        path: '',
        name: 'pos.venta.consultar.home',
        component: () => import('@/views/pos/venta/components/VentasConsultarList.vue'),
      },
      {
        path: ':id',
        name: 'pos.venta.detalle',
        component: () => import('@/views/pos/venta/VentaDetalle.vue'),

      },
    ],
  },
  {
    path: 'ventas/registrar',
    name: 'pos.venta.registrar',
    component: () => import('@/views/pos/venta/VentaRegistrar.vue'),
  },
    {
    path: 'ventas/pedidos',
    name: 'pos.venta.pedidos',
    props: { tipoComprobante: 'ventas' },
    // beforeEnter: (to, from, next) => {
    //   const permissionVentaConPedido = store.state.sucursales.configuracion.ventaConPedido
    //   if (permissionVentaConPedido) {
    //     next()
    //   }


    // },
    component: () => import(/* webpackChunkName: "about" */ '@/views/pos/venta/pedidos/pedidos.venta.vue'),



    meta: { requiresAuth: true, requireArqueoCaja: true, requireCaja: true, requireSucursal: true }


  },

  {
    path: 'ventas/pedidos/nuevo',
    name: 'pos.venta.pedidos.nuevo',
    props: { tipoComprobante: 'ventas' },
    // beforeEnter: (to, from, next) => {
    //   const permissionVentaConPedido = store.state.sucursales.configuracion.ventaConPedido
    //   if (permissionVentaConPedido) {
    //     next()
    //   }


    // },

    component: () => import(/* webpackChunkName: "about" */ '@/views/pos/venta/pedidos/pedido.venta.registrar.vue'),




    meta: { requiresAuth: true, requireArqueoCaja: true, requireCaja: true, requireSucursal: true }


  },
  {
    path: 'ventas/pedidos/actualizar/:id',
    name: 'pos.venta.pedido.actualizar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/pos/venta/pedidos/pedido.venta.actualizar.vue'),
    // beforeEnter: (to, from, next) => {
    //   const permissionVentaConPedido = store.state.sucursales.configuracion.ventaConPedido
    //   if (permissionVentaConPedido) {
    //     next()
    //   }


    // },
    meta: { requiresAuth: true, requireArqueoCaja: true, requireCaja: true, requireSucursal: true }

  },
];
